import { MAP_TYPES } from '@deck.gl/carto';

const MIRAMARGRAVITYSEWER_SOURCE_ID = 'miramarGravitySewerSource';

const source = {
  id: MIRAMARGRAVITYSEWER_SOURCE_ID,
  type: MAP_TYPES.TABLE,
  connection: 'bmpo-smartmetro-09142026',
  data: `us-con-gcp-npr-0000424-011325.diamond.Miramar_Gravity_Sewer_System`,
};

export default source;
